<template>
  <v-flex mb-4>
    <h2
      v-if="!forNotice"
      class="font-weight-bold mb-5 mt-8 d-flex align-center"
    >
      <span>Recent activities</span>
    </h2>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="activities"
          :items-per-page="25"
          :hide-default-header="forNotice"
          :hide-default-footer="forNotice"
          :mobile-breakpoint="MOBILE_BREAK_POINT"
          :loading="!loaded"
          dense
          :footer-props="{
            'items-per-page-options': [25, 50, 100],
            showFirstLastPage: true,
          }"
        >
          <template v-slot:item.Message="{item}">
            <span v-html="item.Message" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-flex>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    forNotice: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    getEventsResultItems: [],
    headers: [
      {text: 'Date', sortable: false, value: 'CreatedAt'},
      {text: 'Message', sortable: false, value: 'Message'},
      {text: '', value: 'action', sortable: false},
    ],
    loaded: false,
  }),
  computed: {
    activities: function() {
      if (this.getEventsResultItems.length === 0) {
        return this.getEventsResultItems
      }
      return this.getEventsResultItems.map((activity) => {
        activity.CreatedAt = moment(activity.CreatedAt).format(
          'YYYY/MM/DD HH:mm'
        )
        const fromItemIdToLastStr = activity.Message.slice(
          activity.Message.indexOf('ItemId = ') + 'ItemId = '.length,
          activity.Message.length
        )
        const id = fromItemIdToLastStr.slice(
          0,
          fromItemIdToLastStr.indexOf('.')
        )
        if (
          activity.Message.indexOf('brain') > -1 ||
          activity.Message.indexOf('Brain') > -1
        ) {
          activity.Message = activity.Message.replace(
            id,
            `<a href="/brains/detail/${id}">${id}</a>`
          )
        } else if (
          activity.Message.indexOf('notebook') > -1 ||
          activity.Message.indexOf('Notebook') > -1
        ) {
          activity.Message = activity.Message.replace(
            id,
            `<a href="/notebooks/${id}">${id}</a>`
          )
        } else if (
          activity.Message.indexOf('studio') > -1 ||
          activity.Message.indexOf('Studio') > -1
        ) {
          activity.Message = activity.Message.replace(
            id,
            `<a href="/studios/${id}">${id}</a>`
          )
        }
        return activity
      })
    },
  },
  methods: {
    async init() {
      // There is no need to suppress multiple calls,
      // because there are no actions such as push() of new items.
      this.loaded = false
      this.getEventsResultItems = []
      const result = await this.getEvents()
      if (!result) {
        return
      }
      this.getEventsResultItems = result.data.Items
      this.loaded = true
    },
  },
  mounted() {
    this.init()
  },
}
</script>
